
















import TopBar from '@/components/TopBar.vue';
import MiddleBar from '@/components/MiddleBar.vue';
import NavBar from '@/components/NavBar.vue';

export default {
  name : 'Header',
  components : {
      TopBar,
      MiddleBar,
      NavBar
  }
}
